import * as React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import OpenScheduleButton from "./OpenScheduleButton";
import Rating, { RatingCount, Stars } from '../common/Rating';
import FavoritedLabel from "../favproviders/FavoritedLabel";
import { Tooltip } from 'reactstrap';
import { getDirectionsUrl } from "../../helpers/location";
import * as Tools from "../../helpers/Tools";
import { translateText } from '../../helpers/data';
import { logUI } from '../../api/andyliticsApi';
const DATE_FORMAT = Tools.getDateFormats();

class Provider extends React.Component {
    constructor(props) {
        super(props);
        this.toggleMyBSWHTooltip = this.toggleMyBSWHTooltip.bind(this);
        this.toggleMapMyBSWHTooltip = this.toggleMapMyBSWHTooltip.bind(this);
        this.addHighlight = this.addHighlight.bind(this);
        this.removeHighlight = this.removeHighlight.bind(this);
        this.state = {
            mybswhTooltipOpen: false,
            mapMybswhTooltipOpen: false,
            invalidInput: false
        };
    }

    toggleMyBSWHTooltip() {
        this.setState({
            mybswhTooltipOpen: !this.state.mybswhTooltipOpen
        });
    }

    toggleMapMyBSWHTooltip() {
        this.setState({
            mapMybswhTooltipOpen: !this.state.mapMybswhTooltipOpen
        });
    }

    addHighlight() {
        this.setState({ highlightItemName: true });
    }

    removeHighlight() {
        this.setState({ highlightItemName: false });
    }

    redirectToMap(item) {
        if (item.locationStreet1) {
            const toAddress = item.locationStreet2 ?
                item.locationStreet1 + ', ' + item.locationStreet2 + ', ' + item.locationCity + ', ' + item.locationState + ' ' + item.locationZip :
                item.locationStreet1 + ', ' + item.locationCity + ', ' + item.locationState + ' ' + item.locationZip
                ;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (typeof window !== 'undefined' && addressUrl) {
                window.open(addressUrl, "_blank");
            }
        }
    }

    indexOfPrimaryLocation(locations) {
        const { locationId } = this.props;
        if (locationId) {   // clicked from Map Pin
            for (let i = 0; i < locations.length; i++) {
                if (locations[i].locationID === locationId) {
                    return i;
                }
            }
        }
        else { // default rendering from FindCareResults
            return 0;
        }
        return 0;
    }

    shouldChoosePrimaryLocation = () => {
        if (this.props.searchModel) {
            const { location, sortBy } = this.props.searchModel;
            if (location === undefined || location === "" || sortBy !== "Distance")
                return true;
            return false;
        }
        return false;
    }

    render() {
        const prov = this.props.providerData;
        let { onlineSchedulingEnabled, serverData, scheduleCampaignReferrer, isProviderMapPinView, translate, t } = this.props;
        const scheduleCampaignActivity = scheduleCampaignReferrer ? { scheduleCampaignReferrer: scheduleCampaignReferrer } : {};
        let apptTimesAmount = this.props.apptTimesAmount ? this.props.apptTimesAmount : 3;
        const specialties = prov.specialties ? prov.specialties.map((s, i) => {
            return <div className="col-12 item-specialty" key={i}>{s.Specialty}</div>;
        }) : [];
        const cerfifications = prov.boardCertifications ? prov.boardCertifications.map((cert, i) => { return cert.boardCertificationName; }) : [];

        let defaultPhone = prov.consumerCallCenterNumber ? prov.consumerCallCenterNumber : (prov.locations && prov.locations.length > 0 ? prov.locations[0].locationPhone : "");

        let moreLocs = prov.locations && (prov.locations.length - 1);

        const locations = prov.locations ? prov.locations.map((loc, i) => {
            return (
                <a key={i} className={loc.locationStreet1 ? "directions-link" : "no-link"} onClick={() => this.redirectToMap(loc)}>
                    <div className="details-icon-prepend">
                        <div className="icon-col">
                            <span className="icon-address" />
                        </div>
                        <div className="details-col">
                            <div className="item-location__name">
                                {loc.distance ? <span className="item-miles">{(loc.distance).toFixed(2)} {translateText(t && translate, "miles", t)} - </span> : ""}
                                {loc.locationName ? <span>{loc.locationName} </span>
                                    : <div className="no-data-dash">
                                        <div />
                                    </div>
                                }
                                {moreLocs > 0 && <span className="more-locs"> (<span className="locs-count">+{moreLocs} {translateText(t && translate, "more", t)}</span>)</span>}
                            </div>
                            <div className="item-location__address">
                                {loc.locationStreet1 ?
                                    <div className="loc-address"><span><span className="item-street">{loc.locationStreet1}</span>{loc.locationStreet2 && <span className="item-suite">, {loc.locationStreet2}</span>}</span><span className="item-city">, {loc.locationCity}</span><span className="item-state">, {loc.locationState}</span><span className="item-zip"> {loc.locationZip}</span> </div>
                                    : <div className="no-data-dash">
                                        <div />
                                    </div>
                                }
                                {moreLocs > 0 && <span className="more-locs"> (<span className="locs-count">+{moreLocs} {translateText(t && translate, "more", t)}</span>)</span>}
                            </div>
                        </div>
                    </div>
                </a>
            );
        }) : [];

        // build the route for the scheduling "more" button...
        let schedule = [];
        let count = 0;
        let earliestAvailableDate = new Date();
        let today = new Date();
        let moreUrl = prov.npi ? `/schedule/${prov.npi}/OpenSchedule` : `/schedule?epicId=${prov.epicID}&scheduleType=OpenSchedule`;
        let visitFilter = this.props.visitType;
        let visitTypeId = "";
        let departmentId = "";
        let linkDate = "";
        let linkTime = "";
        let filterVal = null;
        let openSchedule = [];
        let scheduleDate = '';
        if (this.props.locationId) {
            const filteredLocations = prov.locations && prov.locations.length > 0 && prov.locations.filter(ele => ele.locationID === this.props.locationId);
            const dateTimes = filteredLocations && filteredLocations.length > 0 && filteredLocations[0].openSchedules && filteredLocations[0].openSchedules.dateAndTimes;
            // openSchedule = prov.openSchedule && prov.openSchedule.dateAndTimes;
            openSchedule = dateTimes;
        }
        else {
            openSchedule = prov.locations && prov.locations.length > 0 && prov.locations[0].openSchedules && prov.locations[0].openSchedules.dateAndTimes;
        }

        //Bug 31836: Find Care Search Map Pin: Error displays when clicking on pin with doctor
        if (visitFilter && visitFilter.value !== -1) {
            filterVal = visitFilter.display.filter((visit, i) => visit.key === visitFilter.value);

            if (filterVal && filterVal.length > 0) {
                visitTypeId = filterVal[0].Id;

                if (openSchedule && openSchedule.length > 0) {
                    // get departmentid from the slot that matches the given visit type
                    for (var i = 0; i < openSchedule.length; i++) {
                        const day = openSchedule[i];
                        for (var j = 0; j < day.times.length; j++) {
                            const time = day.times[j];
                            if (time.visitTypeId === visitTypeId) {
                                departmentId = time.departmentId;
                                linkDate = time.time !== "" ? time.time.split("T")[0] : "";
                                linkTime = time.time !== "" ? time.time.split("T")[1] : "";
                                break;
                            }
                        }
                    }
                }
            }

            if (visitTypeId !== "" && departmentId !== "") {
                moreUrl = prov.npi ? `${moreUrl}/${visitTypeId}/${departmentId}` : `${moreUrl}&visitTypeId=${visitTypeId}&departmentId=${departmentId}`;
            }
        }
        else {
            if (openSchedule && openSchedule.length > 0) {
                let openScheduleTimes = openSchedule[0];
                if (openScheduleTimes.times && openScheduleTimes.times.length > 0) {
                    visitTypeId = openScheduleTimes.times[0].visitTypeId;
                    departmentId = openScheduleTimes.times[0].departmentId;
                    linkDate = openScheduleTimes.times[0].time && openScheduleTimes.times[0].time !== "" ? openScheduleTimes.times[0].time.split("T")[0] : "";
                    linkTime = openScheduleTimes.times[0].time && openScheduleTimes.times[0].time !== "" ? openScheduleTimes.times[0].time.split("T")[1] : "";
                    if (visitTypeId && departmentId) {
                        moreUrl = prov.npi ? `${moreUrl}/${visitTypeId}/${departmentId}` : `${moreUrl}&visitTypeId=${visitTypeId}&departmentId=${departmentId}`;
                    }
                } else if (serverData && serverData.enableV3SearchForAllProviders) {
                    departmentId = openScheduleTimes.departmentId;
                    if (departmentId) {
                        moreUrl = prov.npi ? `${moreUrl}/${departmentId}` : `${moreUrl}&departmentId=${departmentId}`;
                    }

                    apptTimesAmount = openSchedule.length >= apptTimesAmount ? apptTimesAmount : openSchedule.length;

                    for (var k = 0; k < openSchedule.length; k++) {
                        let dt = openSchedule[k];
                        count++;
                        if (count <= apptTimesAmount) {
                            let showMobileMonthHeading = false;
                            const month = dt.dateString.split(' ');
                            showMobileMonthHeading = month[0] !== scheduleDate;
                            scheduleDate = month[0];


                            schedule.push(
                                <OpenScheduleButton
                                    npi={prov.npi}
                                    epicId={prov.epicID}
                                    scheduleData={dt}
                                    date={dt.date}
                                    dayString={dt.dayString}
                                    dateString={dt.dateString}
                                    showMobileMonthHeading={showMobileMonthHeading}
                                    key={count}
                                    scheduleCampaignReferrer={scheduleCampaignReferrer}
                                    isProviderMapPinView={isProviderMapPinView}
                                />);
                        }
                        else {
                            break;
                        }
                        if (count > 3) { break; }
                    }
                }
            }
        }

        if (!this.props.locationId) {
            if (openSchedule && openSchedule.length > 0) {
                earliestAvailableDate = new Date(openSchedule[0].date);

                apptTimesAmount = openSchedule.length >= apptTimesAmount ? apptTimesAmount : openSchedule.length;

                for (var k = 0; k < openSchedule.length; k++) {
                    let dt = openSchedule[k];
                    if (serverData && serverData.enableV3SearchForAllProviders) {
                        count++;
                        if (count <= apptTimesAmount) {
                            schedule.push(
                                <OpenScheduleButton
                                    npi={prov.npi}
                                    epicId={prov.epicID}
                                    scheduleData={dt}
                                    date={dt.date}
                                    dayString={dt.dayString}
                                    dateString={dt.dateString}
                                    key={count}
                                    scheduleCampaignReferrer={scheduleCampaignReferrer}
                                />);
                        }
                        else {
                            break;
                        }

                    } else {
                        for (var l = 0; l < dt.times.length; l++) {
                            count++;
                            if (count <= apptTimesAmount) {
                                schedule.push(<OpenScheduleButton npi={prov.npi} epicId={prov.epicID} scheduleData={dt.times[l]} dayString={dt.dayString} key={count} scheduleCampaignReferrer={scheduleCampaignReferrer} />);
                            }
                            else {
                                break;
                            }
                        }
                    }
                    if (count > 3) { break; }
                }
            }
        }
        //Task #34114 : Find Care: Appointment Times in Doctor Cards Doesn't Correlate to Location
        //Get the location and while loop through the date and time array check if loc[0].epicLocationId === time.departmentId.slice(0, -3) and if true add into the list else it will be empty. If location is not availble then return the result.
        // <Provider/> is rendered by SelectedMapPinListing
        else {
            let loc = [];
            let number = 0;
            if (this.props.providerData && this.props.providerData.locations)
                loc = this.props.providerData.locations.filter(location => location.locationID === this.props.locationId);
            if (loc && loc[0] && loc[0].openSchedules && loc[0].openSchedules.dateAndTimes && loc[0].openSchedules.dateAndTimes.length > 0) {
                const openSchedule = loc[0].openSchedules.dateAndTimes;
                apptTimesAmount = openSchedule.length >= apptTimesAmount ? apptTimesAmount : openSchedule.length;

                for (var a = 0; a < openSchedule.length; a++) {
                    if (serverData && serverData.enableV3SearchForAllProviders) {
                        let dt = openSchedule[a];
                        number++;

                        if (number <= apptTimesAmount) {
                            // schedule.push(
                            //     <OpenScheduleButton
                            //         npi={prov.npi}
                            //         epicId={prov.epicID}
                            //         scheduleData={dt}
                            //         date={dt.date}
                            //         dayString={dt.dayString}
                            //         dateString={dt.dateString}
                            //         key={number}
                            //     />);
                        }
                        else {
                            break;
                        }
                    } else {
                        const times = openSchedule[a].times.filter(time => time.departmentId.slice(0, -3) === loc[0].epicLocationId);
                        for (let b = 0; b < times.length; b++) {
                            number++;
                            if (number <= apptTimesAmount) {
                                schedule.push(<OpenScheduleButton npi={prov.npi} scheduleData={times[b]} dayString={openSchedule[a].dayString} key={number} scheduleCampaignReferrer={scheduleCampaignReferrer} />);
                            }
                            else {
                                break;
                            }
                        }
                    }
                    if (number > 3) { break; }
                }
            }
        }

        const defaultProvPhoto = '/images/profile-pic.png';
        const provPhoto = prov.photo ? prov.photo : defaultProvPhoto;
        const provLinkLabel = prov.displayName ? "View " + prov.displayName + " profile" : "View doctor profile";
        const mybswhTooltipMsg = 'This provider allows you to use MyBSWHealth which is a mobile app and web portal where you can: manage appointments, message your doctor, view visit summary, test results, pay bills, and much more!';
        const indexOfLocation = this.props.locationId && prov.locations && prov.locations.length > 1 ? this.indexOfPrimaryLocation(prov.locations) : 0;
        const routeToSearch = moreUrl;
        //const routeBookNowToSearch = prov.npi ? `/schedule/${prov.npi}/OpenSchedule` : `/schedule?providerId=${prov.openSchedule.providerId}&schedule?departmentId=${departmentId}&scheduleType=OpenSchedule`;
        // const routeBookNowToSearch = bookNowUrl;

        return (
            <div className="col-12 find-care-list-item find-care-list-item--provider">
                <div className="row find-care-item-row">
                    <div className="col-12 item-profile-container">
                        <div className="row">
                            <div className="col-12 item-details-container">
                                <div className="item-avatar-container">
                                    <div className="item-img-container" style={{ backgroundImage: `url(${provPhoto})` }} >
                                        <div className="item-img" />
                                    </div>
                                    {(prov.averageRatingStr && prov.averageRatingStr !== "" && prov.averageRatingStr !== '0') &&
                                        <Rating align="bottom" isRatingCount isAverageRatingCount reviewCount={prov.reviewCountStr} starDimension="12px" isVisibleMapView="true" averageRating={prov.averageRatingStr}
                                            starClassName="star-rating--list">
                                            <Stars />
                                            <RatingCount />
                                        </Rating>
                                    }
                                </div>
                                <div className="item-details">
                                    <div className="row">
                                        <Link to={prov.npi ? `providers/${prov.npi}` : `providers?epicId=${prov.epicID}`} onMouseOver={this.addHighlight} onMouseOut={this.removeHighlight} aria-label={provLinkLabel} className="list-item-block-link" onClick={() => logUI("MBHWeb.UI.FindCareResults.ProviderLinkClicked", new Date(), Tools.getURLPath())}>
                                            <div className="col-12 item-name" style={this.state.highlightItemName ? { textDecoration: "underline" } : { textDecoration: "none" }}>
                                                {prov.displayName ? prov.displayName
                                                    : <div className="no-data-dash">
                                                        <div />
                                                    </div>
                                                }
                                            </div>
                                        </Link>
                                        {
                                            specialties && specialties.length > 0 ? specialties[0] : ""
                                        }
                                    </div>
                                    <div className="row">
                                        <div className="col-12 item-location">
                                            {
                                                locations && locations.length > 0 ?
                                                    locations[indexOfLocation] :
                                                    <div className="details-icon-prepend">
                                                        <div className="icon-col">
                                                            <span className="icon-address" />
                                                        </div>
                                                        <div className="details-col">
                                                            <div className="no-data-dash">
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </div>
                                            }
                                        </div>
                                        <div className="col-12 item-phone">
                                            <a className={defaultPhone ? "phone-link" : "no-link"} href={defaultPhone ? "tel:" + (defaultPhone) : "#"}>
                                                <div className="details-icon-prepend">
                                                    <div className="icon-col">
                                                        <span className="icon-phone" />
                                                    </div>
                                                    <div className="details-col">
                                                        {defaultPhone ?
                                                            <div>{defaultPhone}</div>
                                                            : <div className="no-data-dash">
                                                                <div />
                                                            </div>}
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {prov.tierCoverage &&
                                            <div className="col-12 item-tier">
                                                <div className="details-icon-prepend">
                                                    <div className="icon-col">
                                                        {prov.tierCoverage === '1' && '$'}
                                                        {prov.tierCoverage === '2' && '$$'}
                                                    </div>
                                                    <div className="details-col">
                                                        Tier {prov.tierCoverage} In-Network
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className="col-12 item-favorite-label">
                                            <FavoritedLabel NPI={prov.npi} />
                                        </div>
                                    </div>
                                    <div className="row item-perks-container--mapCard">
                                        <div className="col-12 item-perks">
                                            {
                                                prov.usesMyBSWhealth &&
                                                <div className="mybswhealth-perk">
                                                    <div className="mybswh-perk-container" onClick={this.toggleMapMyBSWHTooltip}>
                                                        <img alt="MyBSWHealth" src="/images/mybswh-portal.png" /> portal <span className="icon-question" id={'maptooltip' + prov.npi} />
                                                        <Tooltip placement="top" isOpen={this.state.mapMybswhTooltipOpen} autohide={false} target={'maptooltip' + prov.npi} toggle={this.toggleMapMyBSWHTooltip}>
                                                            {mybswhTooltipMsg}
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                prov.acceptingNewPatients && prov.isReferable &&
                                                <div className="new-patients-perk"><span className="icon-accepts" />Accepts new patients</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="row item-appt-no-open-schedule--mapCard">
                                        {prov.isReferable ?
                                            <div className="col-12">
                                                {(!schedule || schedule.length <= 0 || !onlineSchedulingEnabled) &&
                                                    <div className="call-appt-container">
                                                        {defaultPhone &&
                                                            <a href={"tel:" + defaultPhone} className="phone-link">
                                                                <div className="call-appt-text">Call to schedule</div>
                                                            </a>
                                                        }
                                                    </div>
                                                }
                                            </div> :
                                            <div className="col-12">
                                                <div className="no-appt-container">
                                                    <div className="no-appt-text">Not available for appointments</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={"col-12 item-perks-container--list" + (!prov.usesMyBSWhealth && (!prov.acceptingNewPatients || (prov.acceptingNewPatients && !prov.isReferable)) ? ' no-perks' : '')}>
                                <div className="item-perks">
                                    <div className="row">
                                        {
                                            prov.usesMyBSWhealth &&
                                            <div className="col mybswhealth-perk">
                                                <div className="mybswh-perk-container" onClick={this.toggleMyBSWHTooltip}>
                                                    <img alt="MyBSWHealth" src="/images/mybswh-portal.png" /> portal <span className="icon-question" id={'tooltip' + prov.npi} />
                                                </div>
                                                <Tooltip placement="top" isOpen={this.state.mybswhTooltipOpen} autohide={false} target={'tooltip' + prov.npi} toggle={this.toggleMyBSWHTooltip}>
                                                    {mybswhTooltipMsg}
                                                </Tooltip>
                                            </div>
                                        }
                                        {
                                            prov.acceptingNewPatients && prov.isReferable &&
                                            <div className="col new-patients-perk"><span className="icon-accepts" />Accepts new patients</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 item-appt-options-container">
                        {(onlineSchedulingEnabled && schedule && schedule.length > 0 && prov.isReferable) ?
                            <div>
                                <div className="next-available-appt-heading">Next Available Appointment Times</div>
                                <div className="item-times-container">
                                    <div className="appt-time-list appt-family-list" >
                                        {
                                            schedule
                                        }
                                    </div>
                                    <div className="appt-time-more">
                                        <Link to={{ pathname: routeToSearch, state: { scheduleCampaignReferrer: scheduleCampaignReferrer } }}
                                            className="btn btn-primary" onClick={() => logUI("MBHWeb.UI.FindCareResults.BookNow.Clicked", new Date(), Tools.getURLPath(), scheduleCampaignActivity)}>
                                            <span className="desktop-label">{this.props.buttonText}</span>
                                            <span className="mobile-label--mapCard">{this.props.buttonText}</span>
                                        </Link>
                                    </div>
                                </div>
                            </div> :
                            <div className="item-appt-no-open-schedule--list">
                                {
                                    prov.isReferable ?
                                        <div className="call-appt-container">
                                            {defaultPhone &&
                                                <a href={"tel:" + defaultPhone} className="phone-link">
                                                    <div className="call-appt-icon"><span className="icon-call" /></div>
                                                    <div className="call-appt-text"><span className="call-appt-asterisk"><sup>*</sup></span>Call to schedule</div>
                                                </a>
                                            }
                                        </div> :
                                        <div className="no-appt-container">
                                            <div className="no-appt-text">Not available for appointments</div>
                                        </div>
                                }
                            </div>
                        }
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Provider)